import { IData, ILabelInput, IResponse } from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';

export default class InputLabelsService {
  public static getInputLabels(): Promise<IResponse<IData<ILabelInput[]>>> {
    return ApiService.getAndReturnData('/label');
  }

  public static getPersonalLabels(): Promise<IResponse<IData<ILabelInput[]>>> {
    return ApiService.getAndReturnData('/label/personal');
  }

  public static createInputLabel(name: string): Promise<IResponse<IData<ILabelInput>>> {
    return ApiService.postAndReturnData('/label/save', { name });
  }

  public static searchInputLabels(query: string): Promise<IResponse<IData<ILabelInput[]>>> {
    return ApiService.getAndReturnData(`/label/search?query=${query}`);
  }
}
